import React from "react";

const PlanShiftDelete = ({
    setup,
    loading,
    onClose,
    onConfirm
}) => {

    if (!setup) {
        return null;
    }

    return (

        <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{
                backgroundColor: "rgba(0,0,0,0.5)"
            }}
        >

            <div className="modal-dialog modal-dialog-centered">

                <div className="modal-content">

                    {/* HEADER */}
                    <div className="modal-header">

                        <h5 className="modal-title text-danger">
                            Delete Product Machine Setup
                        </h5>

                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            disabled={loading}
                        />

                    </div>

                    {/* BODY */}
                    <div className="modal-body">

                        <p className="mb-2">
                            Are you sure you want to delete this setup?
                        </p>

                        <div className="alert alert-warning mb-0">

                            <strong>
                                {setup.machine_code || "-"}
                            </strong>

                            {" - "}

                            {setup.product_name || "-"}

                        </div>

                    </div>

                    {/* FOOTER */}
                    <div className="modal-footer">

                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={onConfirm}
                            disabled={loading}
                        >

                            {loading ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                    />
                                    Deleting...
                                </>
                            ) : (
                                "Delete"
                            )}

                        </button>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default PlanShiftDelete;